var _linearGradient, _circle, _radialGradient, _circle2, _path, _path2, _path3, _circle3, _circle4, _line, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _linearGradient2, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Humidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GcsxQE0LCeGOAzjhZW9gva",
    x1: 15.478,
    x2: 33.131,
    y1: -3083.191,
    y2: -3117.537,
    gradientTransform: "matrix(1 0 0 -1 -.022 -3075.814)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19,
    fill: "url(#GcsxQE0LCeGOAzjhZW9gva)"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "GcsxQE0LCeGOAzjhZW9gvb",
    cx: 23.89,
    cy: -3083.395,
    r: 37.884,
    gradientTransform: "matrix(1 0 0 -1 0 -3076)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8cdd1"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 17,
    fill: "url(#GcsxQE0LCeGOAzjhZW9gvb)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.405,28.636c-1.004-1.626-1.854-2.875-2.081-3.205l-0.001-0.001 c-0.363-0.523-1.28-0.524-1.646,0.001c-0.649,0.941-6.343,9.298-6.343,12.901c0,0.883,0.168,1.726,0.462,2.508 C37.525,38.36,41.076,33.94,42.405,28.636z",
    opacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.21,29.284c-1.182-1.941-2.197-3.421-2.298-3.568 c-0.188-0.27-0.636-0.27-0.823,0c-0.255,0.37-6.255,9.098-6.255,12.617c0,0.791,0.146,1.547,0.4,2.252 C37.546,38.172,40.809,34.13,42.21,29.284z",
    opacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#abb4be",
    d: "M16.21,31.767C14.14,29.69,13,26.933,13,24c0-6.065,4.935-11,11-11s11,4.935,11,11 c0,2.9-1.119,5.638-3.152,7.707l-1.427-1.4C32.084,28.612,33,26.373,33,24c0-4.963-4.038-9-9-9s-9,4.037-9,9 c0,2.399,0.933,4.656,2.626,6.354L16.21,31.767z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 5,
    fill: "#c7d3de"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 2,
    fill: "#45494d"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    x2: 27,
    y1: 24,
    y2: 19,
    fill: "none",
    stroke: "#45494d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#abb4be",
    d: "M15,25h-3c-0.552,0-1-0.448-1-1v0c0-0.552,0.448-1,1-1h3V25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#abb4be",
    d: "M33,23h3c0.552,0,1,0.448,1,1v0c0,0.552-0.448,1-1,1h-3V23z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#abb4be",
    d: "M18.343,31.071l-2.121,2.121c-0.391,0.391-1.024,0.391-1.414,0l0,0 c-0.391-0.391-0.391-1.024,0-1.414l2.121-2.121L18.343,31.071z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#abb4be",
    d: "M16.929,18.343l-2.121-2.121c-0.391-0.391-0.391-1.024,0-1.414l0,0c0.391-0.391,1.024-0.391,1.414,0 l2.121,2.121L16.929,18.343z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#abb4be",
    d: "M31.071,29.657l2.121,2.121c0.391,0.391,0.391,1.024,0,1.414l0,0c-0.391,0.391-1.024,0.391-1.414,0 l-2.121-2.121L31.071,29.657z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#abb4be",
    d: "M29.657,16.929l2.121-2.121c0.391-0.391,1.024-0.391,1.414,0l0,0c0.391,0.391,0.391,1.024,0,1.414 l-2.121,2.121L29.657,16.929z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#abb4be",
    d: "M23,15v-3c0-0.552,0.448-1,1-1h0c0.552,0,1,0.448,1,1v3H23z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GcsxQE0LCeGOAzjhZW9gvc",
    x1: 38.195,
    x2: 40.882,
    y1: 1519.443,
    y2: 1537.96,
    gradientTransform: "translate(0 -1490)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#0f80e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006dd9"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GcsxQE0LCeGOAzjhZW9gvc)",
    d: "M45.667,38.333c0,3.405-2.762,6.167-6.167,6.167s-6.167-2.762-6.167-6.167S39.5,26,39.5,26 S45.667,34.928,45.667,38.333z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Humidity);
export default __webpack_public_path__ + "static/media/icons8-humidity.9152040abc2a9286f11ec451745d9573.svg";
export { ForwardRef as ReactComponent };